module.exports = __webpack_public_path__ + "img/flooding.e4d4f99b.png";